import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../https.service';

@Injectable({
  providedIn: 'root'
})
export class ClientListService {

  constructor(private httpService: HttpService) {}

  /**
   * GET https://adminapi.digicoffer.com/consumer
   * Uses sendReGetRequest() → prepends environment.queryUrl
   * Note: queryUrl = 'https://adminapi.dev2.digicoffer.com'
   * If prod URL differs, call sendGetRequest('/consumer') instead.
   */
  // getConsumers(): Observable<any> {
  //   return this.httpService.sendReGetRequest('/consumer') as Observable<any>;
  // }

  getConsumers(accountType?: string): Observable<any> {
    let url = '/consumer';

    if (accountType && accountType !== 'all') {
      url += `?account_type=${accountType}`;
    }

    return this.httpService.sendReGetRequest(url) as Observable<any>;
  }
    
  updateType(uid: string, data: any): Observable<any> {
    return this.httpService.sendRePatchRequest(`/consumer/${uid}`, data) as Observable<any>;
  }
}